import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Content, FlexboxGrid } from 'rsuite';
import FlowPageLayout from '../../components/layout/FlowPageLayout';
import PortalHeader from '../../components/layout/PortalHeader';
import {
  selectCurrentStep,
  selectFlowSteps,
  selectCurrentStepKey,
  selectCurrentFlow,
} from '../../store/slices/flow/flowSelectors';
import {
  setCurrentStep,
  setStepCompletedStatus,
} from '../../store/slices/flow/flowSlice';
import usePlaceNavigate from '../../hooks/usePlaceNavigate';

const PaymentRedirect = () => {
  const placeNavigate = usePlaceNavigate();
  const dispatch = useDispatch();
  const [hideNextButton, setHideNextButton] = useState(true);

  const selectedCurrentStep = useSelector(selectCurrentStep);
  const currentFlow = useSelector(selectCurrentFlow);
  const prevPath = useSelector(selectCurrentStepKey);

  const handleNext = () => {
    placeNavigate(`/dashboard`);
  };

  const handleBack = () => {
    dispatch(
      setStepCompletedStatus({ stepNum: selectedCurrentStep, status: false })
    );
    dispatch(setCurrentStep(selectedCurrentStep - 1));
    placeNavigate(`/${prevPath}`);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setHideNextButton(false);
    }, 30000); // 30 seconds

    return () => clearTimeout(timer);
  }, []);

  return (
    <FlexboxGrid justify="space-between">
      <FlexboxGrid.Item colspan={24}>
        <PortalHeader flow={currentFlow} />
      </FlexboxGrid.Item>
      <FlexboxGrid.Item colspan={24}>
        <Content as="div">
          <FlowPageLayout
            title="Payment"
            onNext={handleNext}
            onBack={handleBack}
            nextButtonText="Return to Dashboard"
            backButtonText="Back"
            hideNextButton={hideNextButton}
            flowProgressStepsSelector={selectFlowSteps}
            currentStep={selectedCurrentStep}
          >
            <p>
              A new browser window has been opened which will allow you to
              complete payment through an external payment provider.
            </p>
            <p>Please continue with your payment in this new browser window.</p>
            <p>
              Once your payment is completed please return to this browser
              window.
            </p>
          </FlowPageLayout>
        </Content>
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
};

export default PaymentRedirect;
